var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 1.93,
    y: 11.522,
    width: 9.617,
    height: 12.478,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 12.453,
    y: 11.522,
    width: 9.617,
    height: 12.478,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 0,
    y: 0,
    width: 24,
    height: 10.611,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5142fc",
    result: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5 -3.501)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,42.3a1.583,1.583,0,0,0,1.583,1.583h8.034V31.41H8Z",
    transform: "translate(-2.57 -16.387)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3.5, 3.5)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,42.3a1.583,1.583,0,0,0,1.583,1.583h8.034V31.41H8Z",
    transform: "translate(-6.07 -19.89)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.58,43.888h8.034A1.583,1.583,0,0,0,43.2,42.3V31.41H33.58Z",
    transform: "translate(-17.627 -16.387)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3.5, 3.5)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.58,43.888h8.034A1.583,1.583,0,0,0,43.2,42.3V31.41H33.58Z",
    transform: "translate(-21.13 -19.89)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.835,11.144H19.9a4.546,4.546,0,0,0,1.815-1.025,4.123,4.123,0,0,0,0-5.465,3.423,3.423,0,0,0-5.124,0A6.2,6.2,0,0,0,15.5,7.228a6.374,6.374,0,0,0-1.091-2.574,3.423,3.423,0,0,0-5.124,0,4.123,4.123,0,0,0,0,5.465A4.546,4.546,0,0,0,11.1,11.144H4.165a.672.672,0,0,0-.665.678v1.613a.672.672,0,0,0,.665.678H26.835a.672.672,0,0,0,.665-.678V11.822A.672.672,0,0,0,26.835,11.144Zm-16.627-1.9a2.805,2.805,0,0,1,0-3.71,2.171,2.171,0,0,1,3.276,0c.64.7,1.107,3.247,1.314,5.117C13.1,10.424,10.835,9.926,10.207,9.244Zm6,1.407c.206-1.87.674-4.418,1.314-5.117a2.171,2.171,0,0,1,3.276,0,2.805,2.805,0,0,1,0,3.71C20.165,9.926,17.9,10.424,16.2,10.651Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3.5, 3.5)",
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.835,11.144H19.9a4.546,4.546,0,0,0,1.815-1.025,4.123,4.123,0,0,0,0-5.465,3.423,3.423,0,0,0-5.124,0A6.2,6.2,0,0,0,15.5,7.228a6.374,6.374,0,0,0-1.091-2.574,3.423,3.423,0,0,0-5.124,0,4.123,4.123,0,0,0,0,5.465A4.546,4.546,0,0,0,11.1,11.144H4.165a.672.672,0,0,0-.665.678v1.613a.672.672,0,0,0,.665.678H26.835a.672.672,0,0,0,.665-.678V11.822A.672.672,0,0,0,26.835,11.144Zm-16.627-1.9a2.805,2.805,0,0,1,0-3.71,2.171,2.171,0,0,1,3.276,0c.64.7,1.107,3.247,1.314,5.117C13.1,10.424,10.835,9.926,10.207,9.244Zm6,1.407c.206-1.87.674-4.418,1.314-5.117a2.171,2.171,0,0,1,3.276,0,2.805,2.805,0,0,1,0,3.71C20.165,9.926,17.9,10.424,16.2,10.651Z",
    transform: "translate(-3.5 -3.5)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.3badd4ef31ddb84b10677a48b9cf19e6.svg";
export { ForwardRef as ReactComponent };